import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronRight, Home, ArrowLeft } from 'lucide-react';

const routeNames = {
  '/dashboard': 'Dashboard',
  '/family-members': 'Family Accounts',
  '/demat': 'Demat Accounts',
  '/las': 'LAS Accounts',
  '/mtf': 'MTF Accounts',
  '/debt-management': 'Debt Insights',
  '/banks': 'Bank Accounts',
  '/accounts': 'Accounts',
  '/companies': 'Know your Stock',
  '/transactions': 'Transactions',
  '/performance': 'Performance',
  '/imports': 'Imports',
  '/capital-gains': 'Capital Gains',
};

const Breadcrumb = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get current path and build breadcrumb items
  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  // Build breadcrumb trail
  const breadcrumbs = [
    { path: '/dashboard', label: 'Dashboard', icon: Home }
  ];
  
  if (pathSegments.length > 0) {
    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const label = routeNames[currentPath] || segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
      
      // Don't add Dashboard twice
      if (currentPath !== '/') {
        breadcrumbs.push({ path: currentPath, label });
      }
    });
  }
  
  // Don't show breadcrumb on Dashboard
  if (location.pathname === '/dashboard') {
    return null;
  }
  
  const handleBack = () => {
    // Go to parent route or dashboard
    if (breadcrumbs.length > 2) {
      navigate(breadcrumbs[breadcrumbs.length - 2].path);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="mb-4 flex items-center justify-between">
      <nav className="flex items-center space-x-1 text-sm">
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          const Icon = crumb.icon;
          
          return (
            <React.Fragment key={crumb.path}>
              {index > 0 && (
                <ChevronRight size={14} className="text-gray-400 mx-1" />
              )}
              <button
                onClick={() => !isLast && navigate(crumb.path)}
                className={`flex items-center gap-1 px-2 py-1 rounded transition-colors ${
                  isLast 
                    ? 'text-gray-800 font-medium cursor-default' 
                    : 'text-gray-500 hover:text-primary hover:bg-gray-100'
                }`}
                disabled={isLast}
              >
                {Icon && <Icon size={14} />}
                <span>{crumb.label}</span>
              </button>
            </React.Fragment>
          );
        })}
      </nav>
      
      <button
        onClick={handleBack}
        className="flex items-center gap-1 px-3 py-1.5 text-sm text-gray-600 hover:text-primary hover:bg-gray-100 rounded-lg transition-colors"
      >
        <ArrowLeft size={16} />
        <span>Back</span>
      </button>
    </div>
  );
};

export default Breadcrumb;
